import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';
import { PagePermissionsAccordion } from './PagePermissionsAccordion';
import { currentRolePermissionsSelector } from '@selectors/role';
import './index.scss';

export const RoleConfigurationList = () => {
  const rolePermissions = useSelector(currentRolePermissionsSelector);
  return (
    <div className="role-configuration-list-container">
      <Typography
        data-testid="role-permissions-subtitle"
        className="role-permissions-heading"
        component="h2"
        variant="h2"
      >
        Role permissions
      </Typography>
      {rolePermissions &&
        rolePermissions.map((pagePermission, index) => {
          return (
            <PagePermissionsAccordion
              pagePermission={pagePermission}
              key={`${pagePermission.name}-${index}`}
            />
          );
        })}
    </div>
  );
};
